export const subscriptionStatus = {
  active: 'active',
  revoked: 'revoked', // for expired subscriptions, or forcibly revoked ones by admin
  pendingLicenseCheck: 'pending license check',
} as const

export const memberStatus = {
  initial: 'initial',
  invited: 'invited',
  revoked: 'revoked',
} as const